import React, { Component } from "react";
import "./MyMapsPopupLabel.css";
import * as helpers from "../../../helpers/helpers";
import { CompactPicker } from "react-color";
import ColorPicker from "./ColorPicker";
import { PointType, StyleSize, FillColor, StrokeType, StrokeColor, StrokeWidth, Rotation } from "./MyMapsSymbolizerComponents";


class MyMapsPopupLabel extends Component {
	constructor(props) {
		super(props);

		this.sliderMin = 0;
		this.sliderMax = 360;

		this.state = {
			label: props.item !== undefined ? props.item.label : "",
			labelRotation: props.item !== undefined ? this.props.item.labelRotation : 0,
			showLabel: props.item !== undefined ? this.props.item.labelVisible : false,
			fontSize: props.item !== undefined ? parseInt(this.props.item.fontSize.replace("px", "")) : "14px",
			fontColor: props.item !== undefined ? this.props.item.fontColor : "blue",
			strokeColor: "blue",
			colorPickerVisible: false, // Nový stav
		};
		// this.increaseFontSize = this.increaseFontSize.bind(this);
		// this.decreaseFontSize = this.decreaseFontSize.bind(this);
		let strokeWidth = 1;
		let colorPickerButtonId = "sc-mymaps-popup-label-color-button-picker";
	}

	// USING REFS TO LISTEN TO CHANGES FROM MAIN MYMAPS COMPONENT
	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(undefined);
	}

	// Metóda pre zvýšenie veľkosti písma
	adjustFontSize(increment) {
		this.setState(prevState => ({
			fontSize: prevState.fontSize + increment
		}), () => {
			this.props.onFontSizeChange(this.props.item, this.state.fontSize);
		});
	}
	adjustFontColor(fontColor) {
		this.setState(prevState => ({
			fontColor
		}), () => {
			this.props.onFontColorChange(this.props.item, this.state.fontColor);
		});
	}
	// increaseFontSize() {

	// 	console.log("FONT SIZE zo stavu", this.state.fontSize);
	// 	this.setState(prevState => ({
	// 		fontSize: prevState.fontSize + 1
	// 	}, ()=>{
	// 		this.props.onFontSizeChange(this.props.item, this.state.fontSize);
	// 	}));
	// }

	// // Metóda pre zníženie veľkosti písma
	// decreaseFontSize() {
	// 	console.log("FONT SIZE zo stavu", this.state.fontSize);
	// 	this.setState(prevState => ({
	// 		fontSize: prevState.fontSize - 1
	// 	}, ()=>{
	// 		this.props.onFontSizeChange(this.props.item, this.state.fontSize);
	// 	}));

	// }

	// HANDLE PARENT MAKING LABEL CHANGE
	parentLabelChange = (itemInfo, newLabel) => {
		if (itemInfo.id === this.props.item.id) {
			this.setState({ label: newLabel });
		}
	};

	// HANDLE PARENT LABEL VISIBLITY CHANGE
	parentLabelVisibilityChange = (itemInfo, visible) => {
		if (itemInfo.id === this.props.item.id) {
			this.setState({ showLabel: visible });
		}
	};

	// HANDLE LABEL CHANGE IN POPUP
	onLabelChange = (evt) => {
		this.setState({ label: evt.target.value });
		this.props.onLabelChange(this.props.item.id, evt.target.value);
	};

	onLabelVisibilityChange = (event) => {
		this.props.onLabelVisibilityChange(this.props.item.id, event.target.checked);
		this.setState({ showLabel: event.target.checked });
	};
	// THIS IS REQUIRED WHEN CHANGING LABEL FROM POPUP
	componentWillReceiveProps(nextProps) {
		if (nextProps.item.label !== this.state.label) this.setState({ label: nextProps.item.label });

		if (nextProps.item.labelVisible !== this.state.labelVisible) {
			this.setState({ labelVisible: nextProps.item.labelVisible });
		}
	}

	// SLIDER CHANGE EVENT
	onSliderChange = (evt) => {
		this.setState({ labelRotation: evt.target.value });
		this.props.onLabelRotationChange(this.props.item, evt.target.value);
	};
	// onChangeTest = evt => {
	//   this.setState({ checkedTest: evt.target.checked });
	// };

	// OUTLINE BUTTON COLOR PICKER
	onStrokeColorPickerButton = () => {
		this.setState(prevState => ({
			colorPickerVisible: !prevState.colorPickerVisible
		}));
	};

	// STROKE COLOR PICKER
	onStrokeColorPickerChange = (color) => {
		console.log("onStrokeColorPickerChange", color)

		this.setState({ fontColor: color.hex, colorPickerVisible: false }, () => {
			console.log("onStrokeColor", color.hex)
			this.props.onFontColorChange(this.props.item, this.state.fontColor);
		});
	};

	render() {
		const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		const rgbStroke = "rgb(0,0,255)";
		// const rgbStroke = "rgb(" + this.state.strokeColor.r + "," + this.state.strokeColor.g + "," + this.state.strokeColor.b + ")";
		return (
			<div >
				<div className={this.props.visible ? "sc-mymaps-popup-label-toggler" : "sc-hidden"}>
					<div className="sc-mymaps-popup-slider">
						<label className="sc-mymaps-popup-slider-label">Otočiť</label>
						<input type="range" min={this.sliderMin} max={this.sliderMax} value={this.state.labelRotation} step="1" onChange={this.onSliderChange} style={{ width: "170px" }} />
					</div>
					<div className="sc-font-size-control">
						<label className="sc-mymaps-popup-slider-label">Veľkosť písma:</label>
						<span className="sc-font-size-display">{this.state.fontSize}px</span>
						<button onClick={() => this.adjustFontSize(-1)}>-</button><button onClick={() => this.adjustFontSize(1)}>+</button>
					</div>
					<div className="sc-font-size-control control-color">
						<label className="sc-mymaps-popup-slider-label color">Farba:</label>
						<div className="sc-mymaps-fill-color-button">
							<button
								id={this.colorPickerButtonId}
								style={{
									backgroundColor: this.state.fontColor,
									width: "30px",
									height: "15px",
									cursor: "pointer",
									position: "relative",
									top: "3px"
								}}
								onMouseUp={this.onStrokeColorPickerButton}
							/>
						</div>
					</div>
				</div>
				{/* <div>
					<input
					className="sc-mymaps-popup-label-input sc-editable"
					type="text"
					value={this.state.label}
					onChange={this.onLabelChange}
					onFocus={(evt) => {
						helpers.disableKeyboardEvents(true);
					}}
					onBlur={(evt) => {
						helpers.disableKeyboardEvents(false);
					}}
					/>
				</div> */}
				{this.state.colorPickerVisible && (
					<CompactPicker
						color={this.state.fontColor}
						onChangeComplete={this.onStrokeColorPickerChange}
					/>
				)}
			</div>
		);
	}
}

export default MyMapsPopupLabel;
